import { useEffect, useSyncExternalStore } from "react";

// Which part of the page the author is working in, so the footer can offer the save that
// goes with it - Save and Test while on the Test tab. Null is the page as a whole.
let scope: string | null = null;
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

const change = (next: string | null) => {
  scope = next;
  listeners.forEach((listener) => listener());
};

/** Holds the footer's scope while the page is showing it. */
export function useSetFooterScope(next: string | null) {
  useEffect(() => {
    change(next);

    return () => change(null);
  }, [next]);
}

export const useFooterScope = () =>
  useSyncExternalStore(
    subscribe,
    () => scope,
    () => null
  );
